// extracted by mini-css-extract-plugin
export default {"dropdown":"container_dropdown__UX9TG"};